import PresetFormField from 'domain/entity/preset/form/presetFormField';

export enum OptionFieldKey {
    CUSTOM_TITLE = 'custom_title',
    COMPARISON_DISPLAY_MODE = 'comparison_display_mode',
    TEXT_ALIGNMENT = 'text_alignment',
    CHART_LIMIT = 'checkpoints_thresholds',
    GAUGE_MIN_MAX = 'minmax_gauge',
    GAUGE_RANGE = 'range_gauge',
}
export default class OptionsFormField {
    constructor(readonly label: { text: string }, readonly fields: PresetFormField[], readonly key: OptionFieldKey) {}
}
